class CVent {
    constructor() {
        this.speakersURL = "https://itblapi.wpenginepowered.com/wp-json/itblbackend/v1/blocks/speakers?eventCode=";
        this.eventsURL = "https://itblapi.wpenginepowered.com/wp-json/itblbackend/v1/cvent-events";
        this.sessionsURL = "https://itblapi.wpenginepowered.com/wp-json/itblbackend/v1/blocks/sessions?eventCode=";
    }

    getSpeakers(eventId) {
        const settings = {
            "url": this.speakersURL + eventId,
            "method": "GET",
            "timeout": 0
        };

        return $.ajax(settings);
    }

    getEvents() {
        const settings = {
            "url": this.eventsURL,
            "method": "GET",
            "timeout": 0
        };

        return $.ajax(settings);
    }

    getSessions(eventId) {
        const settings = {
            "url": this.sessionsURL + eventId,
            "method": "GET",
            "timeout": 0
        };

        return $.ajax(settings);
    }

    getEventId(eventCode) {
        return this.getEvents().then(events => {
            var eventId = '';
            
            events.forEach(event => {
                if(event.code === eventCode) {
                    eventId = event.id;
                }
            });

            return eventId;
        })
    }
}